import actionCreator from '../../../utils/actionCreator';

const InvoicesActionTypes = ['GET_INVOICES', 'EDIT_INVOICE'];

export const { types: invoicesTypes, actions: invoicesActions } =
  actionCreator(InvoicesActionTypes);
